/**
 * Bootstrap do Svelte. Monta App.svelte no #app, conecta o gate de auth.
 * Auth roda na main thread antes do worker existir; conteúdo do arquivo
 * nunca toca esta camada (ver ADR 0001).
 */
import "./styles/global.css";
import App from "./App.svelte";
import { onAuthStateChanged } from "firebase/auth";
import { getFirebaseAuth } from "./features/auth/firebaseConfig";
import { authStore } from "./features/auth/authStore";
import { isDevBypassActive } from "./features/auth/devBypass";

const target = document.getElementById("app");
if (!target) {
  throw new Error("Elemento #app nao encontrado em index.html");
}

// Em mode='production' (default), import.meta.env.MODE === 'production' é literal
// e o bloco inteiro é DCE'd pelo Vite. Em mode='e2e' (Playwright), o bypass fica
// disponível e isDevBypassActive() decide via ?e2e=1.
if (import.meta.env.MODE !== 'production' && isDevBypassActive()) {
  authStore.setUser({
    uid: "e2e-bypass",
    email: "e2e-bypass@pontotel.com.br",
    displayName: "E2E Bypass",
  });
} else {
  const auth = getFirebaseAuth();
  onAuthStateChanged(auth, (firebaseUser) => {
    if (!firebaseUser || !firebaseUser.email) {
      authStore.setUser(null);
      return;
    }
    authStore.setUser({
      uid: firebaseUser.uid,
      email: firebaseUser.email,
      displayName: firebaseUser.displayName,
    });
  });
}

const app = new App({ target });

export default app;
